import {bookingService} from "../network/services/booking.service";
import {ResponseError} from "../network/response/response-error";

export default {
  namespaced: true,
  state: {
    loading: false,
    bookings: [],
    limit: 10,
    offset: 0,
    hasMore: true
  },
  mutations: {
    SET_LOADING (state, payload) {
      state.loading = !!payload;
    },
    RESET (state) {
      state.bookings = [];
      state.limit = 10;
      state.offset = 0;
      state.hasMore = true
    },
    ADD_BOOKINGS (state, payload) {
      state.bookings.push(...payload);
      state.offset += payload.length;
      if (payload.length < state.limit) {
        state.hasMore = false;
      }
    },
    SET_LIMIT (state, limit) {
      state.limit = limit;
    }
  },
  actions: {
    async fetch (context) {
      const lang = context.rootState.lang.currentLang;
      const accessToken = context.rootState.client.tokens.accessToken;
      const limit = context.state.limit;
      const offset = context.state.offset;
      context.commit('SET_LOADING', true);
      const response = await bookingService.fetchHistoryWidget(accessToken, limit, offset, lang);
      const bookings = response.get('Auth.bookings');
      if (!(bookings instanceof ResponseError)) {
        context.commit('ADD_BOOKINGS', bookings);
      } else {
        //TODO catch errors
      }
      context.commit('SET_LOADING', false);
    },
    reset (context) {
      context.commit('RESET');
      context.commit('SET_LOADING', false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/booking-history.store.js